export default __webpack_public_path__ + "static/media/WandaMagic2.e59a6539.png";